import Person from './Person';

class PersonInList {
  constructor(id, name, email, phone) {
    this.person = new Person(id, name, email, phone);
  }
}

export default PersonInList;
